import { compose, hoistStatics } from 'recompose';
import ButtonIcons from './buttonIcons';

const enhance = compose();

export default hoistStatics(enhance)(ButtonIcons);
